import PropTypes from 'prop-types';
import React from 'react';

import { TitleStyled } from './TrlNewsTitle.styles';

export const TrlNewsTitle = ({
  title,
  maxLines,
  overflowNotHidden,
  headlineNews,
  handleClick,
}) => (
  <TitleStyled
    maxLines={maxLines}
    overflowNotHidden={overflowNotHidden}
    headlineNews={headlineNews}
    onClick={handleClick}
    isClickable={!!handleClick}
  >
    {title}
  </TitleStyled>
);

TrlNewsTitle.propTypes = {
  title: PropTypes.string.isRequired,
  maxLines: PropTypes.number,
  overflowNotHidden: PropTypes.bool,
  headlineNews: PropTypes.bool,
  handleClick: PropTypes.func,
};
